export const DHS_API_MAP_SERVER_COUNTRIES_DATA_URL = 'https://previewapi.dhsprogram.com/rest/dhs/data';

export const ADMIN_1_VECTOR_DATA_WASH_TYPE =
  'https://gis.dhsprogram.com/arcgis/rest/services/Admin2SDR/Admin1WASH_Indicators/MapServer/1';

export const ADMIN_2_VECTOR_DATA =
  'https://gis.dhsprogram.com/arcgis/rest/services/Admin2SDR/Admin2SDR_Indicators/MapServer/4';
